import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Head from './Head';
import Body from './Body';

const PaymentsTable = ({
  items,
  config,
  isLoading,
  onChangeVisibility,
}) => (
  <>
    <Table>
      <Head
        config={config}
      />
      <Body
        isLoading={isLoading}
        items={items}
        config={config}
        onChangeVisibility={onChangeVisibility}
      />
    </Table>
  </>
);

PaymentsTable.propTypes = {
  items: PropTypes.array,
  config: PropTypes.object,
  isLoading: PropTypes.bool,
  onChangeVisibility: PropTypes.func,
};

export default PaymentsTable;
